import { globalCss } from '@grupoboticario/flora-react-system'
import { fonts } from './importFonts'

export const resetCssStyles = globalCss({
  '*, *::before, *::after': {
    boxSizing: 'border-box',
    WebkitFontSmoothing: 'antialiased',
    MozOsxFontSmoothing: 'grayscale',
  },
  'html, body, div, span, applet, object, iframe, h1, h2, h3, h4, h5, h6, p, blockquote, pre, a, abbr, acronym, address, big, cite, code, del, dfn, em, img, ins, kbd, q, s, samp, small, strike, strong, sub, sup, tt, var, b, u, i, center, dl, dt, dd, ol, ul, li, fieldset, form, label, legend, table, caption, tbody, tfoot, thead, tr, th, td, article, aside, canvas, details, embed, figure, figcaption, footer, header, hgroup, main, menu, nav, output, ruby, section, summary, time, mark, audio, video':
    {
      margin: '0',
      padding: '0',
      border: '0',
      font: 'inherit',
      fontSize: '100%',
      verticalAlign: 'baseline',
    },
  'article, aside, details, figcaption, figure, footer, header, hgroup, main, menu, nav, section': {
    display: 'block',
  },
  '*[hidden]': {
    display: 'none',
  },
  a: {
    textDecoration: 'none',
  },
  body: {
    background: '$background',
    color: '$nonInteractivePredominant',
    fontFamily: '$secondary',
    lineHeight: '1',
    scrollBehavior: 'auxiliarooth',
    textRendering: 'optimizeSpeed',
  },
  'ol, ul, li': {
    listStyle: 'none',
  },
  'blockquote, q': {
    quotes: 'none',
  },
  'blockquote:before, blockquote:after, q:before, q:after': {
    content: '',
  },
  table: {
    borderSpacing: '0',
  },
  fieldset: {
    border: 0,
    margin: 0,
    padding: 0,
  },
  button: {
    fontFamily: '$secondary',
  },
  '@font-face': fonts,
})
